"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructIssuerProof = void 0;
const core_1 = require("../core");
const base_1 = require("../core/base");
const encoding_1 = require("../encoding");
const merkle_1 = require("../merkle");
const index_1 = require("./index");
async function constructIssuerProof(client, issuer) {
    // The first transaction of a token issuer must be the one that created it
    const txn0url = `${issuer}#txn/0`;
    const { receipts, transaction } = await client.queryUrl(txn0url, { prove: true });
    // Get a chain proof (from any chain, ends in a BVN anchor)
    if (receipts.length === 0) {
        throw new Error(`Asked for proofs but got none`);
    }
    const proof2 = receipts[0].proof;
    // Convert the response to a Transaction
    if (transaction.body.type != "createToken") {
        throw new Error(`Expected first transaction of ${issuer} to be createToken but got ${transaction.body.type}`);
    }
    const header = new core_1.TransactionHeader({
        principal: transaction.header.principal,
        initiator: index_1.Buffer.from(transaction.header.initiator, "hex"),
        memo: transaction.header.memo,
        metadata: transaction.header.metadata
            ? index_1.Buffer.from(transaction.header.metadata, "hex")
            : undefined,
    });
    const body = new core_1.CreateToken(transaction.body);
    const txn = new core_1.Transaction({ body, header });
    // Prove that the body is part of the transaction
    const proof1 = {
        start: await (0, base_1.hashBody)(body),
        startIndex: 0,
        end: await (0, base_1.hashBody)(body),
        endIndex: 0,
        anchor: await txn.hash(),
        entries: [
            {
                hash: await (0, index_1.sha256)((0, encoding_1.encode)(header)),
                right: false,
            },
        ],
    };
    // Prove the BVN anchor
    const anchorRes = await client.queryAnchor(proof2.anchor);
    const proof3 = anchorRes.receipt.proof;
    // Assemble the full proof
    const receipt = (0, merkle_1.combineReceipts)((0, merkle_1.combineReceipts)(new merkle_1.Receipt(proof1), new merkle_1.Receipt(proof2)), new merkle_1.Receipt(proof3));
    return { receipt, transaction: body };
}
exports.constructIssuerProof = constructIssuerProof;
//# sourceMappingURL=util.js.map